import {
  AxiosDeleteRequestOptions,
  AxiosGetRequestOptions,
  AxiosPostRequestOptions,
  AxiosPutRequestOptions,
} from '@/package';
import type { ProjectApi } from '@/type';
import { apiOf } from '@/util';

export const create = apiOf<
  ProjectApi.Create.Request,
  ProjectApi.Create.Response
>(new AxiosPostRequestOptions({ url: '/v1/miri/project' }));

export const getDetail = apiOf<
  ProjectApi.GetDetail.Request,
  ProjectApi.GetDetail.Response
>(new AxiosGetRequestOptions({ url: '/v1/miri/project/:pProjectID' }));

export const getList = apiOf<
  ProjectApi.GetList.Request,
  ProjectApi.GetList.Response
>(new AxiosGetRequestOptions({ url: '/v1/miri/project' }));

export const getCount = apiOf<
  ProjectApi.GetCount.Request,
  ProjectApi.GetCount.Response
>(new AxiosGetRequestOptions({ url: '/v1/miri/project/count' }));

export const update = apiOf<
  ProjectApi.Update.Request,
  ProjectApi.Update.Response
>(new AxiosPutRequestOptions({ url: '/v1/miri/project/:pProjectID' }));

export const mapUser = apiOf<
  ProjectApi.MapUser.Request,
  ProjectApi.MapUser.Response
>(new AxiosPostRequestOptions({ url: '/v1/miri/project/:pProjectID/user' }));

export const unMapUser = apiOf<
  ProjectApi.UnMapUser.Request,
  ProjectApi.UnMapUser.Response
>(new AxiosDeleteRequestOptions({ url: '/v1/miri/project/:pProjectID/user' }));

export const remove = apiOf<
  ProjectApi.Remove.Request,
  ProjectApi.Remove.Response
>(new AxiosDeleteRequestOptions({ url: '/v1/miri/project/:pProjectID' }));

export const importProject = apiOf<
  ProjectApi.Import.Request,
  ProjectApi.Import.Response
>(
  new AxiosPostRequestOptions({
    url: '/v1/miri/project/import',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
);
